import { useNavigate } from 'react-router-dom';
import { useEffect, useRef, useState } from 'react';
import { MenuProps, BarIconsProps, barIcons } from './utils/barIcons';

import JPIcon from '../../assets/logo/jp-branco.svg';
import { CustomFlowbiteTheme, Tooltip } from 'flowbite-react';
import { useAuth } from '../../context/AuthContext';

interface SideBarProps {
  versao: string;
}

export function SideBar({ versao }: SideBarProps) {
  const divRef = useRef<HTMLDivElement>(null);
  const [isOpenMenu, setIsOpenMenu] = useState({ isOpen: false, name: '' });
  const [menu, setMenu] = useState<MenuProps[]>([]);
  const navigate = useNavigate();
  const { cookies } = useAuth();

  const themeTooltip: CustomFlowbiteTheme['tooltip'] = {
    base: 'absolute inline-block z-20 rounded-lg py-2 px-3 text-sm font-medium shadow-sm',
  };

  function handleMenu({ link, menu: menuButtons, name }: BarIconsProps) {
    if (link) {
      navigate(link);
      if (isOpenMenu.isOpen) {
        setIsOpenMenu({ isOpen: false, name: '' });
        setMenu([]);
      }
      return;
    }
    if (menuButtons && isOpenMenu.name !== name) {
      setMenu(menuButtons);
      setIsOpenMenu({ isOpen: true, name });
    } else {
      setIsOpenMenu({ isOpen: false, name: '' });
      setMenu([]);
    }
  }

  const handleClickOutside = (event: MouseEvent) => {
    if (divRef.current && !divRef.current.contains(event.target as Node) && isOpenMenu.isOpen) {
      // Função a ser acionada ao clicar fora da div
      setIsOpenMenu({ isOpen: false, name: '' });
      setMenu([]);
    }
  };

  useEffect(() => {
    if (isOpenMenu.isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    // Limpar o evento ao desmontar o componente
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpenMenu]);

  function handleMenuOption(link: string) {
    setIsOpenMenu({ isOpen: false, name: '' });
    setMenu([]);
    navigate(link);
  }

  function renderMenuBar(link: string, menu: string, i: number, perfils?: number[]) {
    if (perfils && perfils.length > 0) {
      const hasPerfil = perfils.find(item => item === cookies?.user?.id_perfil)
      if (hasPerfil) {
        return (
          <button
            onClick={() => handleMenuOption(link)}
            key={i}
            className={`mx-4 w-[90%] rounded-md px-2 py-2 text-start text-white hover:bg-blue-800 hover:underline hover:opacity-90 `}
          >
            <p>{menu}</p>
          </button>
        )
      }
    }
  }

  function renderMenu(barIcon: BarIconsProps) {
    if (barIcon.perfils && barIcon.perfils.length > 0) {
      const hasPerfil = barIcon.perfils.find((item) => item === cookies?.user?.id_perfil);
      if (hasPerfil) {
        const { link, Icon, name, menu } = barIcon;
        return (
          <Tooltip content={name} key={name} placement="right" theme={themeTooltip}>
            <button
              key={name}
              className=" flex h-16 w-[3.2rem] flex-col  items-center justify-center hover:fill-white hover:opacity-100"
              onClick={() => handleMenu({ link, Icon, name, menu })}
            >
              <Icon
                size={20}
                className={` h-full w-full p-2 hover:bg-white hover:fill-primary hover:opacity-100 ${isOpenMenu.name === name ? ' bg-white fill-primary ' : 'shadow--md bg-primary fill-white'
                  }`}
              />

              {/* <p className="">{name}</p> */}
            </button>
          </Tooltip>
        );
      }
    } else {
      const { link, Icon, name, menu } = barIcon;
      return (
        <Tooltip content={name} placement="right" theme={themeTooltip}>
          <button
            key={name}
            className=" flex h-16 w-[3.2rem] flex-col  items-center justify-center hover:fill-white hover:opacity-100"
            onClick={() => handleMenu({ link, Icon, name, menu })}
          >
            <Icon
              size={20}
              className={` h-full w-full p-2 hover:bg-white hover:fill-primary hover:opacity-100 ${isOpenMenu.name === name ? ' bg-white fill-primary ' : 'shadow--md bg-primary fill-white'
                }`}
            />

            {/* <p className="">{name}</p> */}
          </button>
        </Tooltip>
      );
    }
  }
  // duration-200 ease-in-out  ${!isOpenMenu.isOpen ? 'w-0' : ' translate-x-0'}
  return (
    <>
      <section className="flex" ref={divRef}>
        <div className="w-15  flex  h-screen flex-col items-center justify-start bg-primary py-3 shadow-md">
          <img src={JPIcon} alt="" className="-mt-3 h-14 w-14  px-1 " />
          {barIcons.map((barIcon) => renderMenu(barIcon))}
          <p className="absolute bottom-0 text-sm text-white">v. {versao}</p>
        </div>
        <div
          className={`drawer z-20 -mx-[0.2rem] flex h-screen w-80 flex-col items-center justify-start bg-primary pt-4 ${!isOpenMenu.isOpen && 'hidden'
            } `}
        >
          <p className="my-2 text-xl text-white">{isOpenMenu.name}</p>
          {menu?.map(({ link, name, perfils }, i) => (
            // <button
            //   onClick={() => handleMenuOption(link)}
            //   key={i}
            //   className={`mx-4 w-[90%] rounded-md px-2 py-2 text-start text-white hover:bg-blue-800 hover:underline hover:opacity-90 `}
            // >
            //   <p>{name}</p>
            // </button>
            renderMenuBar(link, name, i, perfils,)
          ))}
        </div>
      </section>
    </>
  );
}
